import { configureStore } from '@reduxjs/toolkit';
import { restV4Api } from '@/api/generated/rest-v4-api';

export const createStore = () =>
  configureStore({
    reducer: {
      [restV4Api.reducerPath]: restV4Api.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(restV4Api.middleware),
  });

export const store = createStore();

export type AppStore = ReturnType<typeof createStore>;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
